module.exports = __webpack_public_path__ + "static/media/klaver.2b4f9283.svg";